import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { Enums } from '../../shared/models/enums';
import { CellRendererElementSubTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element-Subtype.enum';
import { CellRendererElementTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class EdgeFacultyGridService {
    constructor() { }
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    private callbackProjDOcUploadModalClose = new Subject<any>(); // Source
    eventCallbackProjDocuUploadModalClose$ = this.callbackProjDOcUploadModalClose.asObservable(); // Stream

    //constructor(private http: HttpClient) { }

    dateCellRenderer(rowData, field) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], 'yyyy-MM-dd hh:mm a', 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    cols: Array<TableColumn> = [
        {
            field: 'email',
            header: 'EDGE Account Email',
          //  sort: true,
            sortName: 'email',
            pinned: true,
            filter: { type: FilterTypes.text },
            isEnable: 'enableOverlay',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onApplicantEmailClickForEdgeFaculty',
                elementsubType: CellRendererElementSubTypes.email
            }
        },
        {
            field: 'firstName',
            header: 'First Name',
            //sort: true,
            sortName: 'firstName',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'lastName',
            header: 'Last Name',
           // sort: true,
            sortName: 'lastName',
            filter: { type: FilterTypes.text }
        }, {
            field: 'gender',
            header: 'Gender',
            //sort: true,
            //sortName: 'Gender',
            //filter: {
            //    type: FilterTypes.select, selectOptions: [
            //        { label: 'All', value: '' },
            //        { label: 'Female', value: 'Female' },
            //        { label: 'Male', value: 'Male' },
            //        { label: 'Other', value: 'Other' },
            //        { label: 'Prefer not to answer', value: 'Prefer not to answer' }
            //    ]
            //}
        },
        
        {
            field: 'status',
            header: 'Status',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Submitted', value: 'Submitted' },
                    { label: 'Application accepted', value: 'Application accepted' },
                    { label: 'Application returned', value: 'Application returned' },
                    { label: 'Agreement signed', value: 'Agreement signed' },
                    { label: 'License issued', value: 'License issued' },
                    { label: 'License revoked', value: 'License revoked' },
                    { label: 'License expired', value: 'License expired' }
                ]
            },
            
        }
        ,
        {
            field: 'country',
            header: 'Country',
            
        },
        {
            field: 'city',
            header: 'City',
        }
        ,
        {
            field: 'isAgreementSigned',
            header: 'Is Agreement Signed?',
            
           
        },
        
        {
            field: 'facultyLicenseNumber',
            header: 'EDGE Faculty Id',
            sort: true,
            sortName: 'facultyLicenseNumber',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'facultyLicenseExpiryDate',
            header: 'Faculty Id Expiry Date',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'isDownload',
            header: 'Download',
            displayName: ' ',
            isEnable: 'isDownload',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDownloadEdgeFcultyCertificateClick',
                elementsubType: CellRendererElementSubTypes.download,
            }
        }
    ];


    
}

